import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon } from "lucide-react";
import { images, recentBuyers } from "../data/content";
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const GAP = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [minutes, setMinutes] = useState(2);
  useEffect(() => {
    let hideTimer: number;
    let cycleTimer: number;
    const show = () => {
      setIndex(Math.floor(Math.random() * recentBuyers.length));
      setMinutes(1 + Math.floor(Math.random() * 9));
      setOpen(true);
      hideTimer = window.setTimeout(() => setOpen(false), VISIBLE_FOR);
      cycleTimer = window.setTimeout(show, VISIBLE_FOR + GAP);
    };
    const start = window.setTimeout(show, FIRST_DELAY);
    return () => {
      window.clearTimeout(start);
      window.clearTimeout(hideTimer);
      window.clearTimeout(cycleTimer);
    };
  }, []);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed bottom-[92px] left-3 right-3 z-50 flex md:bottom-6 md:left-6 md:right-auto" aria-live="polite" data-id="element-45" data-mp="163whj56omo8n">
      <AnimatePresence data-id="element-46" data-mp="1fw241ze60dgg">
        {open && <motion.div key={`${buyer.name}-${minutes}`} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-full max-w-sm items-center gap-3 rounded-2xl border border-brand-sage/25 bg-paper p-3 pr-4 shadow-[0_14px_36px_-12px_rgba(30,50,25,0.35)]" data-id="element-47" data-mp="1fv0wi4wcy93h">
            <img src={images.mainMockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-cream object-contain p-1" data-id="element-48" data-mp="s8aswz4d26gr" />
            <div className="min-w-0" data-id="element-49" data-mp="23klg8q0c5adt">
              <p className="text-sm leading-snug text-ink" data-id="element-50" data-mp="23nps89k1laf1">
                <strong data-id="element-51" data-mp="2ao1ngz0szrqa">{buyer.name}</strong> from <strong data-id="element-52" data-mp="2aqxjuix068cm">{buyer.country}</strong>
              </p>
              <p className="text-[13px] leading-snug text-ink/70" data-id="element-53" data-mp="2fm35dgmhtl06">
                just purchased the digital book <span className="font-semibold text-brand-olive" data-id="element-54" data-mp="2knaepk4aas8y">The Aroma Lab™</span>
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-medium text-brand-cta" data-id="element-55" data-mp="2plbyk79javlh">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-56" data-mp="1rzmz6jhvert6" />
                Verified · {minutes} min ago
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}